import React, { PropsWithChildren } from "react";
import {
  StyleSheet,
  Text as RNText,
  TextProps,
  Platform,
  View,
} from "react-native";

import { useAppFonts } from "hook";
import { colors } from "asset/constant";
import { fontSizes } from "./helper/fontSizes";
import { fontWeights } from "./helper/fontWeights";

const Text = (props: PropsWithChildren<TextT & TextProps>) => {
  const { fontIsReady } = useAppFonts();

  const styles = StyleSheet.create({
    txt: {
      textAlign: props.align || "right",
      fontSize: fontSizes(props.size),
      color: props.color || colors.text.normal,
      fontFamily: fontWeights(props.weight, props.lang ?? "fa"),
    },
  });
  if (!fontIsReady) {
    return null;
  }

  return Platform.OS !== "web" ? (
    <RNText
      allowFontScaling={false}
      {...props}
      style={{ ...styles.txt, ...props.style }}
    />
  ) : (
    <View style={{ top: props.top ?? 2, ...props.style }}>
      <RNText
        allowFontScaling={false}
        {...props}
        style={{ ...styles.txt, ...props.style }}
      />
    </View>
  );
};

export default Text;
